// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__eZ34S","fallback":"avatar_fallback__PNQfh"};